import { CenterGroup } from '../../../lib/types/models/center-group/center-group'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function unassignTeflFromCenterGroup(centerId: number, groupId: number) {
  return restApiClient
    .url(constructApiUrl(API.centers.unassignTeflFromCenterGroup.url, { id: centerId, groupId }))
    .delete<CenterGroup>()
}
